import { Loader } from "lucide-react";
import React, { ChangeEvent } from "react";
import { Option } from "react-multi-select-component";
import PrimaryBtn from "src/Components/GlobalComponents/primaryBtn";
import SelectDropdown from "src/Components/GlobalComponents/SelectDropdown";
import CustomWebsiteDropdown from "src/Components/GlobalComponents/Widget/CustomWebsiteDropdown";
import SimpleInput from "src/Components/SimpleInput";
import { validateAndFilterPhoneNumber } from "src/helpers/helperFunctions";

const OrderPersonalDetails = ({
  payload,
  setPayload,
  setActiveTab,
  userSuggestions,
  fetchUserSuggestions,
  showSuggestions,
  setShowSuggestions,
  loadingSuggestions,
  errors,
  setErrors,
  validatePersonalDetailsForm,
}: {
  payload: any;
  setPayload: (payload: any) => void;
  setActiveTab: (tab: string) => void;
  userSuggestions: any[];
  fetchUserSuggestions: (value: string) => void;
  showSuggestions: boolean;
  setShowSuggestions: (show: boolean) => void;
  loadingSuggestions: boolean;
  errors: {
    [key: string]: string;
  };
  setErrors: React.Dispatch<React.SetStateAction<{
    [key: string]: string;
  }>>;
  validatePersonalDetailsForm: () => boolean;
}) => {
  const address = [
    { label: "Home", value: "Home" },
    { label: "Work", value: "Work" },
    { label: "Other", value: "Other" },
  ];

  return (
    <div className="w-full max-w-[900px]">
      <div className="flex flex-col w-full gap-2 bg-[#F6FBFF] rounded-lg p-3">
        <h2 className="font-Poppins-SemiBold font-size-18px mb-2 theme-color-green">
          Personal Details
        </h2>
        <div className="flex flex-col">
          <div className="w-full relative">
            <CustomWebsiteDropdown
              options={userSuggestions.map((suggestion) => ({
                label: suggestion.email,
                value: suggestion.email,
              }))}
              data={
                payload?.userDetails?.email
                  ? [
                      {
                        label: payload?.userDetails?.email,
                        value: payload?.userDetails?.email,
                      },
                    ]
                  : []
              }
              setData={(data) => {
                console.log("Changed Data", data);
                let findEmail = userSuggestions.find(
                  (suggestion) => suggestion.email === data[0]?.value
                );
                setPayload({
                  ...payload,
                  userDetails: {
                    ...payload.userDetails,
                    email: findEmail ? findEmail.email : "",
                    _id: findEmail ? findEmail._id : "",
                    gender: findEmail ? findEmail?.gender : "",
                  },
                });
                setErrors((prev) => ({ ...prev, email: data[0]?.value ? "" : "Email is required" }));
              }}
              labelText="Customer Email"
              isRequired
              isSearch
              onSearchChange={(value) => {
                fetchUserSuggestions(value);
              }}
              loading={loadingSuggestions}
              error={errors.email}
            />
          </div>
          <div className="w-full">
            <SimpleInput
              value={payload.mobileNumber}
              onChange={(value: string) => {
                const { filteredValue, errorMessage } = validateAndFilterPhoneNumber(value);
                setPayload({
                  ...payload,
                  mobileNumber: filteredValue,
                });
                setErrors((prev) => ({ ...prev, mobileNumber: errorMessage }));
              }}
              labelText="Mobile Number"
              isLabel
              isRequired
              maxLength={15}
              minLength={10}
              error={errors.mobileNumber}
            />
          </div>
          <div className="w-full">
            <SimpleInput
              value={payload.firstName}
              onChange={(value: string) => {
                let filteredValue = value.replace(/[^a-zA-Z\s]/g, "");
                setPayload({ ...payload, firstName: filteredValue });
                setErrors((prev) => ({ ...prev, firstName: "" }));
              }}
              labelText="First & Last Name"
              isLabel
              isRequired
              maxLength={30}
              minLength={3}
              error={errors.firstName}
            />
          </div>
        </div>
      </div>
      <div className="w-full mt-3 flex justify-end">
        <PrimaryBtn
          ButtonText="Next"
          onClick={() => {
            if (validatePersonalDetailsForm()) {
              setActiveTab("Add Products");
            }
          }}
          btnExtraStyle={{
            backgroundColor: "#00443F",
            color: "white",
            borderRadius: 50,
          }}
        />
      </div>
    </div>
  );
};

export default OrderPersonalDetails;
